import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Badge,
  Label,
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import AdminHeader from "components/Headers/AdminHeader";
import { urlDecodedId } from "components/CommonComponents/encodeDecodeFunction";
import { getInstructorDetailById } from "action/instructor";
import DetailsHeader from "components/CommonComponents/DetailsHeader";

function InstructorDetails() {
  const authData = JSON.parse(localStorage.getItem("p") || "{}");
  const role = authData?.role;
  const { id } = useParams();
  const navigate = useNavigate();
  const [instructorDetailData, setInstructorDetailData] = useState(null);
  const [showAlternative, setShowAlternative] = useState({
    loader: false,
    error: "",
  });
  const decodedId = id ? urlDecodedId(id) : null;

  useEffect(() => {
    if (decodedId) {
      getInstructorDetail(decodedId);
    }
  }, [decodedId]);

  const getInstructorDetail = async (id) => {
    try {
      setShowAlternative({ loader: true, error: "" });

      const res = await getInstructorDetailById(id);

      if (res?.code === 200) {
        setInstructorDetailData(res?.data);
        setShowAlternative({ loader: false, error: "" });
      } else {
        setShowAlternative({
          loader: false,
          error: res?.message || "Failed to load instructor details",
        });
      }
    } catch (error) {
      setShowAlternative({
        loader: false,
        error: "Something went wrong while loading instructor details",
      });
    }
  };

  const handleBack = () => {
    navigate(
      role === "SUPER_ADMIN" ? "/super-admin/trainee" : "/admin/trainee",
    );
  };

  const handleEdit = () => {
    navigate(
      role === "SUPER_ADMIN"
        ? `/super-admin/instructor/edit/${id}`
        : `/admin/instructor/edit/${id}`,
      {
        state: { mode: "edit" },
      },
    );
  };

  return (
    <>
      <AdminHeader />

      <Container fluid className="mt--6">
        {/* Header */}
        {/* <Row className="justify-content-center">
          <Col md="12">
            <Card>
              <CardHeader className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <i
                    className="fa fa-chevron-left mr-2 cursor"
                    onClick={() =>
                      navigate(
                        role === "SUPER_ADMIN"
                          ? "/super-admin/instructor"
                          : "/admin/instructor",
                      )
                    }
                  />
                  <h3 className="mb-0">Trainer Details</h3>
                </div>
                <Button
                  className="btn-deep-blue"
                  onClick={() =>
                   
                    navigate(
                      role === "SUPER_ADMIN"
                        ? "/super-admin/instructor/add-new"
                        : `/admin/instructor/edit/${id}`,
                      {
                          state: { mode: "edit" },
                        },
                    )
                    }
                >
                  <i className="fa fa-pencil mr-1" />
                  Edit
                </Button>
              </CardHeader>
            </Card>
          </Col>
        </Row> */}

        <DetailsHeader
          onBack={handleBack}
          backTooltip="Back to Trainer "
          showProfile={true}
          title={
            `${instructorDetailData?.user?.firstName || ""} ${instructorDetailData?.user?.lastName || ""
              }`.trim() || "Trainer Details"
          }
          status={instructorDetailData?.user?.status}
          onEdit={handleEdit}
          editLabel="Edit"
          editTooltip="Edit Trainer"
          editIcon="fa fa-pencil"
          chips={[
            {
              id: "trainerEmailChip",
              icon: "fas fa-envelope",
              value: instructorDetailData?.user?.email || "-",
              tooltip: instructorDetailData?.user?.email || "-",
            },
            {
              id: "trainerPhoneChip",
              icon: "fas fa-phone",
              value: instructorDetailData?.user?.mobile || "-",
              tooltip: instructorDetailData?.user?.mobile || "-",
            },
            {
              id: "trainerExperienceChip",
              icon: "fas fa-briefcase",
              name: "Experience",
              value: instructorDetailData?.totalExperience || "-",
              tooltip: `Experience: ${instructorDetailData?.totalExperience || "-"
                }`,
            },
          ]}
        />

        {showAlternative.loader ? (
          <div className="loaderContainer">
            <i className="fa fa-spinner fa-spin fa-2xl loader" />
          </div>
        ) : showAlternative.error ? (
          <div className="loaderContainer text-muted d-flex flex-column">
            <h4 className="text-muted">No Instructor Data Available</h4>
            <span className="text-danger">{showAlternative.error}</span>
          </div>
        ) : (
          <Row className="mt-3">
            {/* LEFT */}
            <Col md="6">
              <Card className="h-100">
                <CardHeader>
                  <h4 className="mb-0">Basic Information</h4>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md="6">
                      <div className="mb-3 d-flex flex-column align-items-start ">
                        <Label className="small-label text-muted mb-1">
                          Name
                        </Label>

                        <div className="small-text">
                          {`${instructorDetailData?.user?.firstName || ""} ${instructorDetailData?.user?.lastName || ""
                            }`.trim()}
                        </div>
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="mb-3 d-flex flex-column align-items-start ">
                        <Label className=" small-label text-muted mb-1">

                          Email

                        </Label>
                        <small className="small-text">
                          {instructorDetailData?.user?.email || "—"}
                        </small>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="6">
                      <div className="mb-3 d-flex flex-column align-items-start ">
                        <Label className="small-label text-muted mb-1">

                          Mobile Number

                        </Label>
                        <div className="small-text">
                          {instructorDetailData?.user?.mobile || "—"}
                        </div>
                      </div>
                    </Col>

                    <Col md="6">
                      <Label className="small-label text-muted mb-1">

                        Status

                      </Label>
                      <div>
                        <Badge
                          color={
                            instructorDetailData?.user?.status === "ACTIVE"
                              ? "success"
                              : "warning"
                          }
                          className="badge-lg"
                        >
                          {instructorDetailData?.user?.status || "—"}
                        </Badge>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>

            {/* RIGHT */}
            <Col md="6">
              <Card className="h-100">
                <CardHeader>
                  <h4 className="mb-0">Professional Information</h4>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md="6">
                      <div className="mb-3">
                        <Label className="small-label text-muted mb-1">
                          Experience Year
                        </Label>
                        <div className="small-text">
                          {instructorDetailData?.totalExperience || "—"}
                        </div>
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="mb-3">
                        <Label className="small-label text-muted mb-1">

                          Gender

                        </Label>
                        <div className="small-text">
                          <div className="small-text">
                            {instructorDetailData?.gender || "—"}
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="12">
                      <Label className="small-label text-muted mb-1">

                        Skills

                      </Label>

                      {instructorDetailData?.skills?.length ? (
                        <ol className="pl-3 mt-1 mb-0">
                          {instructorDetailData.skills.map((skill, index) => (
                            <li
                              key={skill.ID || index}
                              className="small-text mb-1"
                            >
                              {skill.name}
                            </li>
                          ))}
                        </ol>
                      ) : (
                        <div className="small-text">N/A</div>
                      )}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </Container>
    </>
  );
}

export default InstructorDetails;
